const json = `
<p>版本生效日期：2026年6月22日</p>
<p>版本更新日期：2026年6月22日</p>
<p>广州钱柜物联科技有限公司（以下简称“我们”）深知个人信息和隐私安全对您的重要性。我们将按照法律法规要求，遵循合法、正当、必要和诚信原则，保护您在使用 DV Link（以下简称“本应用”）过程中的相关信息。</p>
<p>请您在使用本应用前仔细阅读并理解本隐私政策。本政策将帮助您了解：我们如何收集和使用信息、如何存储和保护信息、是否共享或披露信息、您如何管理自己的信息，以及如何联系我们。</p>
<p class="subTitle">一、适用范围</p>
<p>本隐私政策适用于 DV Link iOS / iPadOS 应用及其相关功能。</p>
<p>本应用是一款用于 USB 直录设备录像导入与本地播放的工具。其核心流程为：您通过 iOS 系统文件选择器选择 USB 设备文件夹或录像文件夹，本应用在获得您授权后读取该文件夹中的录像文件，并支持将录像下载到手机本地进行播放、管理、分享或导出。</p>
<p>本应用当前版本不属于 USB 设备控制中心，不通过 USB 私有协议实时控制设备，不自动监听 USB 插入事件，不绕过系统文件选择器静默读取 OTG 根目录。</p>
<p>本应用当前版本不提供账号注册、登录功能，暂不接入第三方 SDK，不进行广告投放、跨应用追踪或第三方广告归因。</p>
<p>在首次使用本应用或使用涉及个人信息处理、系统权限的相关功能时，我们会通过应用内提示、系统权限弹窗或其他适当方式向您说明处理目的，并在依法取得必要授权或同意后处理相关信息。对于相册、通知等非基本功能所必需的权限，您可以拒绝或撤回授权；拒绝或撤回后，您可能无法使用对应扩展功能，但不影响设备文件夹选择、录像扫描、本地播放等基本功能。</p>
<p class="subTitle">二、我们如何收集和使用信息</p>
<p>我们仅会为实现本应用功能所必需的目的处理相关信息。根据本应用当前产品设计，主要涉及以下信息：</p>
<p class="subTitle">1. 设备文件夹授权与访问</p>
<p>当您点击“选择设备文件夹”并通过 iOS 系统文件选择器选择 USB 设备根目录或录像目录时，本应用会在您授权的范围内读取该文件夹及其子文件夹中的文件。</p>
<p>我们可能会在您的设备本地保存以下信息，用于恢复授权、显示授权状态、扫描录像和避免重复下载：</p>
<p>• 您选择的设备文件夹名称、相对路径或授权记录；</p>
<p>• iOS 系统提供的文件夹访问授权凭证；</p>
<p>• 最近授权时间、最近访问时间、最近扫描时间；</p>
<p>• 设备信息文件中包含的设备名称、型号、序列号、固件版本等信息（如设备目录中提供此类信息）。</p>
<p>上述信息主要用于：识别您授权的设备文件夹、恢复访问权限、展示当前授权状态、扫描设备录像、减少您重复选择文件夹的操作。</p>
<p class="subTitle">2. 设备录像扫描与列表展示</p>
<p>在您授权的设备文件夹范围内，本应用会扫描可识别的录像文件，并在本地生成录像列表。为展示和管理录像，本应用可能在您的设备本地处理以下信息：</p>
<p>• 录像文件名、文件后缀、文件大小；</p>
<p>• 文件创建时间、修改时间、录像时间；</p>
<p>• 录像时长、分辨率、编码格式等媒体信息；</p>
<p>• 录像在设备文件夹中的相对路径；</p>
<p>• 下载状态、本地保存路径、缩略图路径、可选校验值。</p>
<p>这些信息用于展示设备录像列表、按日期或状态筛选录像、判断是否已下载、生成缩略图、播放本地录像和管理本地存储空间。</p>
<p class="subTitle">3. 录像下载、本地播放与本地管理</p>
<p>当您选择将设备中的录像下载到手机时，本应用会将您选定的录像复制到本应用的本地存储空间。下载完成后，即使 USB 设备未连接，您也可以在“本地录像”中播放、查看详情、分享、导出或删除本地副本。</p>
<p>本应用对本地录像的删除仅作用于手机中的本地副本，不会删除、移动、重命名或修改 USB 设备中的原始文件。</p>
<p class="subTitle">4. 存储空间与下载任务信息</p>
<p>为支持下载前空间检查、下载进度展示和本地存储管理，本应用可能在您的设备本地处理：</p>
<p>• 待下载文件数量、总大小、下载进度；</p>
<p>• 本地录像占用空间、缓存占用空间；</p>
<p>• 下载成功、失败、取消或重试等任务状态；</p>
<p>• 设备断开、授权失效、存储不足、播放失败等本地状态信息。</p>
<p>上述信息用于保证下载过程可见、可恢复，并帮助您管理本地存储空间。</p>
<p class="subTitle">5. 分享与导出</p>
<p>当您主动使用系统分享、导出功能时，本应用会调用 iOS 系统分享能力，将您选择的本地录像交由系统或您选择的其他应用处理。您选择的第三方应用如何处理相关文件，适用该第三方应用自身的隐私政策和服务规则。</p>
<p>除非您主动分享或导出，本应用不会主动向第三方发送您的录像文件。</p>
<p class="subTitle">6. 客服与反馈</p>
<p>如果您通过电子邮件或其他方式联系我们，我们可能会处理您主动提供的联系方式、问题描述、截图、设备型号、系统版本、应用版本或相关附件，用于响应您的咨询、排查问题和改进服务。</p>
<p>请您在反馈中避免提供与问题无关的敏感个人信息。如您主动提供含有个人信息的录像、图片或文件，我们将仅在处理您反馈所必需的范围内使用。</p>
<p class="subTitle">7. 崩溃日志与性能数据</p>
<p>为保障应用稳定运行、排查崩溃问题、优化扫描、下载和播放体验，在您同意本隐私政策或我们依法取得必要授权后，本应用可能会通过我们自有的日志和分析能力收集必要的运行诊断信息，包括：</p>
<p>• 崩溃日志、异常类型、崩溃发生时间、调用栈等故障排查信息；</p>
<p>• 应用启动、页面响应、录像扫描、下载任务、播放加载等性能数据；</p>
<p>• 设备型号、系统版本、应用版本、语言和地区设置等基础环境信息。</p>
<p>上述信息仅用于问题定位、稳定性分析、兼容性适配和产品体验改进。我们会尽量避免在日志中记录完整文件名、完整路径、录像缩略图或录像内容，并对运行诊断信息采取最小化、去标识化或脱敏处理。我们不会通过崩溃日志或性能数据收集您的录像文件内容、相册全部内容、通讯录、短信、通话记录、精确位置、账号密码或用于广告追踪的信息。</p>
<p>本应用当前版本暂不接入第三方统计、广告、归因或崩溃分析 SDK。如后续版本接入第三方 SDK，我们将在接入前评估其必要性，更新本隐私政策和 App Store 隐私信息，并按照法律法规和平台规则向您告知相关信息类型、使用目的、第三方名称及处理方式。</p>
<p class="subTitle">三、我们不会主动收集的信息</p>
<p>在当前版本中，除非您通过系统能力另行授权或主动提供，本应用不会主动收集：</p>
<p>• 您的姓名、身份证件号码、通讯录、短信、通话记录；</p>
<p>• 您的账号、密码、登录凭证；</p>
<p>• 您的精确位置或行踪轨迹；</p>
<p>• 您的相机、麦克风实时内容；</p>
<p>• 您的相册全部内容；</p>
<p>• 您的支付信息、银行卡信息；</p>
<p>• 用于广告追踪的 IDFA 或跨应用追踪数据；</p>
<p>• 与本应用核心功能无关的其他个人信息。</p>
<p class="subTitle">四、设备权限说明</p>
<p class="subTitle">1. 文件夹访问权限</p>
<p>本应用通过 iOS 系统文件选择器获取您选择文件夹的访问授权。只有在您主动选择并授权后，本应用才会读取该授权范围内的文件。</p>
<p>您可以通过本应用中的“重新选择设备文件夹”“清除授权”等功能管理授权状态。清除授权不会删除本地已下载录像，也不会删除 USB 设备中的原始文件。</p>
<p class="subTitle">2. 本地存储</p>
<p>本应用会在设备本地保存下载后的录像文件、缩略图、授权记录、下载状态和必要的索引信息，以便提供本地播放和本地管理功能。</p>
<p class="subTitle">3. 系统分享</p>
<p>当您主动选择分享或导出录像时，本应用会调用 iOS 系统分享能力。您可以自行选择是否分享、分享给谁以及使用哪个应用完成分享。</p>
<p class="subTitle">4. 相册权限</p>
<p>当您主动选择将本地录像保存到系统相册，或在反馈、分享、导出等场景中选择使用相册内容时，本应用可能会请求相册相关权限。本应用仅会在您授权或主动操作的范围内处理相关照片或视频，不会主动读取或扫描您的相册全部内容。</p>
<p>您可以在 iOS 系统“设置”中管理本应用的相册访问权限。</p>
<p class="subTitle">5. 通知权限</p>
<p>当您希望接收下载完成、下载失败、任务状态变化或其他与本应用功能相关的提醒时，本应用可能会请求系统通知权限。通知内容仅用于向您提示本应用内的任务状态或必要服务信息，不用于广告推送或跨应用追踪。</p>
<p>您可以在 iOS 系统“设置”中开启、关闭或调整本应用的通知权限。</p>
<p class="subTitle">五、我们如何存储信息</p>
<p>本应用处理的设备文件夹授权记录、录像索引、本地录像文件、缩略图、下载任务状态等主要保存在您的 iPhone 或 iPad 本地。</p>
<p>在当前产品边界下，本应用不提供云端同步功能，不会主动将您的录像文件上传至我们的服务器。</p>
<p>崩溃日志、性能数据、设备型号、系统版本、应用版本等运行诊断信息可能会上传并保存于我们的服务端，用于故障排查、稳定性分析和产品优化。除法律法规另有规定或处理投诉、纠纷所必需外，运行诊断信息的保存期限原则上不超过 180 日；超出必要期限后，我们会删除或匿名化处理。</p>
<p>您通过邮件向我们反馈问题时，相关邮件内容将按照处理咨询、排查问题和履行法律义务所必需的最短期限保存。除法律法规另有规定或处理投诉、纠纷所必需外，客服与反馈信息的保存期限原则上不超过 2 年；超出必要期限后，我们会删除或匿名化处理相关信息。</p>
<p class="subTitle">六、我们如何保护信息安全</p>
<p>我们会采取合理可行的安全措施保护您的信息安全，包括：</p>
<p>• 仅在您授权的文件夹范围内读取文件；</p>
<p>• 尽量将录像文件、授权记录和索引信息保存在设备本地；</p>
<p>• 对删除本地录像等重要操作设置确认流程；</p>
<p>• 限制无关信息的收集和使用；</p>
<p>• 限制崩溃日志、性能数据等运行诊断信息的访问范围；</p>
<p>• 对运行诊断信息进行最小化、去标识化或脱敏处理；</p>
<p>• 在处理客服反馈时限制信息使用范围。</p>
<p>请您理解，任何信息处理方式都无法保证绝对安全。请您妥善保管自己的设备、系统账号和本地文件，避免将包含敏感内容的录像分享给不可信对象。</p>
<p class="subTitle">七、我们如何共享、转让、公开披露信息</p>
<p class="subTitle">1. 共享</p>
<p>当前版本中，我们不会主动向第三方共享您的个人信息或录像文件。以下由您主动发起或法律法规要求的情形除外：</p>
<p>• 您主动使用系统分享、导出功能，将本地录像交由您选择的应用或接收方处理；</p>
<p>• 法律法规、司法机关、行政机关依法要求提供的情形。</p>
<p>为响应您的客服请求，或为排查崩溃、优化性能而处理必要运行诊断信息时，我们会通过自有能力处理相关信息，不会向第三方统计、广告、归因或崩溃分析 SDK 提供相关信息。</p>
<p>当前版本暂不接入第三方 SDK。如后续接入第三方 SDK 或委托第三方处理个人信息，我们将按照法律法规要求进行评估，并在本隐私政策中说明第三方名称、处理目的、处理方式和信息种类。</p>
<p class="subTitle">2. 转让</p>
<p>如因合并、分立、解散、收购、资产转让等原因需要转移个人信息，我们将向您告知接收方的名称和联系方式，并要求接收方继续履行本隐私政策及法律法规规定的义务。</p>
<p class="subTitle">3. 公开披露</p>
<p>我们不会公开披露您的个人信息或录像文件，除非取得您的单独同意，或法律法规另有规定。</p>
<p class="subTitle">八、您如何管理自己的信息</p>
<p>您可以通过以下方式管理相关信息：</p>
<p>• 重新选择设备文件夹：在应用内重新发起系统文件选择器授权；</p>
<p>• 清除设备文件夹授权：移除本应用保存的文件夹访问授权记录；</p>
<p>• 删除本地录像：删除手机中已下载的本地录像副本；</p>
<p>• 管理本地存储：查看和清理本地录像、缓存和相关文件；</p>
<p>• 管理相册权限：在 iOS 系统“设置”中关闭或调整本应用的相册访问权限；</p>
<p>• 管理通知权限：在 iOS 系统“设置”中关闭或调整本应用的通知权限；</p>
<p>• 撤回分享：如您通过第三方应用分享文件，请在对应第三方应用中管理已分享内容；</p>
<p>• 联系我们：如需查询、复制、更正、补充、删除您通过客服渠道提供的信息或与您相关的运行诊断信息，或撤回相关处理授权，可通过本政策列明的联系方式联系我们。</p>
<p>请注意，清除授权或删除本地录像不会影响 USB 设备中的原始文件。卸载本应用通常会删除本应用沙盒内保存的本地数据，但 iOS 系统或您手动导出的文件可能仍保存在其他位置。</p>
<p>对于您通过本政策列明方式提出的个人信息权利请求，我们会在核验必要信息后依法处理，并在十五个工作日内或法律法规规定的期限内回复。对于无端重复、需要过多技术手段、给他人合法权益带来风险或明显不切实际的请求，我们可能依法予以拒绝，并向您说明原因。</p>
<p class="subTitle">九、儿童个人信息保护</p>
<p>本应用并非专门面向不满十四周岁的儿童设计。若您是不满十四周岁的儿童，请在父母或其他监护人的陪同和同意下使用本应用。</p>
<p>如果监护人发现儿童在未取得监护人同意的情况下向我们提供了个人信息，请通过本政策列明的联系方式联系我们，我们会依法及时处理。</p>
<p class="subTitle">十、跨境提供</p>
<p>当前版本中，本应用的核心功能主要在您的设备本地完成，我们不会主动将您的录像文件或本地录像索引上传至境外服务器。</p>
<p>如您通过电子邮件向我们反馈问题，邮件服务或网络传输可能涉及您所选择服务提供商的处理规则。若未来业务发生变化，需要向境外提供个人信息，我们将按照法律法规要求履行告知、取得同意或其他必要程序。</p>
<p class="subTitle">十一、隐私政策的更新</p>
<p>我们可能会根据产品功能、法律法规或平台规则变化更新本隐私政策。更新后，我们会在本应用或相关页面中发布更新后的隐私政策，并标明生效日期。</p>
<p>如更新涉及个人信息处理目的、处理方式、处理种类、保存期限或共享对象的重大变化，我们将以适当方式向您提示；依法需要取得您同意的，我们会在取得您的同意后再处理相关信息。</p>
<p class="subTitle">十二、如何联系我们</p>
<p>个人信息处理者：广州钱柜物联科技有限公司</p>
<p>联系地址：广州市南沙区南沙街道华汇国际广场916</p>
<p>联系电话：020 34974033</p>
<p>支持邮箱：naxclow@163.com</p>
<p>如您对本隐私政策或个人信息保护相关事项有任何疑问、意见、投诉、建议，或希望行使您的个人信息相关权利，可以通过以上联系方式联系我们。我们会在收到您的请求并核验必要信息后，依法在合理期限内予以处理和回复。</p>
`

export default json
